<!-- =========================================================================================
    File Name: i18n.vue
    Description: I18n demo
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="mb-8">
      <div class="vx-row">
        <div class="vx-col md:w-3/4 sm:w-2/3 w-full">
          <import-excel :onSuccess="loadDataInTable" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/3 w-full">
          <card-download-template type="custom"></card-download-template>
        </div>
      </div>
    </div>

    <vx-card v-if="state === 'list' ">
      <vs-table stripe pagination :max-items="maxItems" search :data="tableData">
        <template slot="header">
          <div class="w-1/3">
            <vs-button color="warning" type="filled" @click="submit('generated')" v-if="pms ('CustomerImport', 'create', 'b') ">สร้าง QrCode</vs-button>
          </div>
        </template>

        <template slot="thead">
          <vs-th :sort-key="heading" v-for="heading in header" :key="heading">{{ heading }}</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="col" v-for="(col, indexcol) in data[indextr]" :key="indexcol + col">
              {{ col }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
<!--    <vx-card v-if="state === 'generated'">-->
<!--      <div class="vx-row" v-if="state === 'generated'">-->
<!--        <div class="vx-col mr-auto ml-auto">-->
<!--          <div class="vx-row flex mb-1">-->
<!--            <span class="vx-col flex-1 text-left label">ยอดรวม</span>-->
<!--            <div class="vx-col flex-1 text-right"><span class="money-bold">{{ 100 | numberFormat }} </span> <span class="label-bold">บาท</span></div>-->
<!--          </div><br>-->
<!--          <div class="vx-row flex mb-1">-->
<!--            <div class="mr-auto ml-auto" ref="qrcode"></div>-->
<!--          </div>-->
<!--          <div class="vx-row flex mb-1">-->
<!--            <span class="vx-col flex-1 text-left label">ใช้แอปพลิเคชันธนาคารสแกน QR CODE นี้ เพื่อชำระเงินรองรับทุกธนาคาร โดยไม่มีค่าธรรมเนียม</span>-->
<!--          </div>-->
<!--          <div class="vx-row flex mb-1">-->
<!--            <span class="vx-col flex-1 text-left label-link cursor-pointer"><a @click="btnReload()"><u><b>คลิกเพื่ออัพเดตยอด</b></u></a></span>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </vx-card>-->

    <vs-popup title="ชำระผ่าน QR CODE" :active.sync="paymentPopup">
      <div class="vx-row">
        <div class="vx-col mr-auto ml-auto">
          <div class="vx-row flex">
            <span class="vx-col flex-1 text-left label">{{ company }}</span>
          </div><br>
          <div class="vx-row flex">
            <span class="vx-col flex-1 text-left label">ค่างวด</span>
            <span class="vx-col flex-1 text-right label-bold">{{ amount | numberFormat }}</span>
          </div><br>
          <br>
          <div class="vx-row flex mb-1">
            <span class="vx-col flex-1 text-left label">ยอดรวม</span>
            <div class="vx-col flex-1 text-right"><span class="money-bold">{{ amount | numberFormat }} </span> <span class="label-bold">บาท</span></div>
          </div><br>
          <div class="vx-row flex mb-1">
            <div class="mr-auto ml-auto" ref="qrcode"></div>
          </div>
          <div class="vx-row flex mb-1">
            <span class="vx-col flex-1 text-left label">ใช้แอปพลิเคชันธนาคารสแกน QR CODE นี้ เพื่อชำระเงินรองรับทุกธนาคาร โดยไม่มีค่าธรรมเนียม</span>
          </div>
          <vs-divider position="center"> {{index + 1}}/{{ tableData.length }} </vs-divider>
          <div class="vx-row flex mb-1">
            <span v-if="index > 0" class="vx-col flex-1 text-left label-link cursor-pointer"><a @click="btnBack()"><u>ย้อนกลับ</u></a></span>
            <span v-if="(index+1) < tableData.length" class="vx-col flex-1 text-right label-link cursor-pointer"><a @click="btnNext()"><u><b>ถัดไป</b></u></a></span>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import ImportExcel from './Excel/ImportExcel.vue'
import * as QRCode from 'easyqrcodejs'
import vSelect from 'vue-select'
import { mapGetters, createNamespacedHelpers } from 'vuex'
import Divider from "@/views/components/vuesax/divider/Divider.vue";
const moment = require('moment');
const { mapState: mapCustomerStates } = createNamespacedHelpers('Customer')

export default {
  components: {
    Divider,
    ImportExcel,
    vSelect,
    CardDownloadTemplate: () => import('@/components/shared/card/CardDownloadTemplate.vue'),
  },
  data () {
    return {
      form: [],
      importType: { label: 'Borrowers',  value: 'Borrowers' },
      maxItems: 100,
      state: 'null',
      meta: {},
      tableData: [],
      header: [],
      result: [],
      paymentPopup: false,
      index: 0,
      qrcode: null,
      company: "",
      payeeId: "",
      ref1: "",
      ref2: "",
      amount: 0,
    }
  },
  filters: {
    resultStatus: function(res) {
      if(res.success){
        return "Success"
      }else{
        return "Error"
      }
    }
  },
  async created() {
    this.pms ('CustomerImport', 'visible', 'r')
  },
  computed: {
    ...mapCustomerStates(['status']),
    ...mapGetters({
      importCustomTypesOptions :'Master/importCustomTypesOptions',
    }),

  },
  methods: {
    convExcelDate (dd) {
      const utc_days  = Math.floor(dd - 25569);
      const utc_value = utc_days * 86400;
      const date_info = new Date(utc_value * 1000);
      return moment(date_info).format("YYYY-MM-DD")
    },
    loadDataInTable ({ results, header, meta }) {
      const vm = this
      vm.header = header
      vm.tableData = results
      vm.meta = { fileName: meta.fileName}
      vm.state = 'list'
      vm.importType = {
        label: meta.importType,
        value: meta.importType
      }
      if( meta.importType === "GeneratesQrCode"){
        vm.tableData = results.map(result =>{
          return {
            ...result,
          }
        })
      }
    },
    async submit () {
      const vm = this
      vm.index = 0;
      await vm.createQrPayment(vm.index);
      vm.paymentPopup = true;
    },
    async createQrPayment(index){
      const vm = this
      vm.company = vm.tableData[index]["Company"];
      vm.payeeId = vm.tableData[index]["PayeeId"];
      vm.ref1 = vm.tableData[index]["Ref1"];
      vm.ref2 = vm.tableData[index]["Ref2"];
      vm.amount = Number(vm.tableData[index]["Amount"]);
      const cr = '\r'
      const text = '|'
        + vm.payeeId + cr
        + vm.ref1 + cr
        + vm.ref2 + cr
        + vm.amount.toFixed(2).replace(/\./g, '')
      if(vm.qrcode) vm.qrcode.clear()
      const options = {
        text: text,
        width: 256,
        height: 256,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.M,
        // ==== Title
        title: '', // content
        titleFont: "bold 18px Arial", //font. default is "bold 16px Arial"
        titleColor: "#004284", // color. default is "#000"
        titleBgColor: "#fff", // background color. default is "#fff"
        titleHeight: 10, // height, including subTitle. default is 50
        titleTop: 25, // draws y coordinates. default is 30

        // ==== SubTitle
        // subTitle: 'QR subTitle', // content
        // subTitleFont: "14px Arial", // font. default is "14px Arial"
        // subTitleColor: "#004284", // color. default is "gray"
        // subTitleTop: 40, // draws y coordinates. default is 50

        // ==== Logo
        // logo: "../images/qrcodelogo/Thai_QR_Payment_Logo-03.png", // Relative address, relative to easy.qrcode.min.js
        // logo: require("@/assets/images/logo/logo-wel-barcode.png"), // Relative address, relative to easy.qrcode.min.js
        // logo:"http://127.0.0.1:8020/easy-qrcodejs/demo/logo.png",
        logoWidth: 40, // widht. default is automatic width
        logoHeight: 40, // height. default is automatic height
        // logoBgColor:'#fffff', // Logo backgroud color, Invalid when logBgTransparent is true; default is '#ffffff'
        logoBgTransparent: true, // Whether use transparent image, default is false
      }
      vm.qrcode  = new QRCode(vm.$refs.qrcode, options);
    },
    btnBack() {
      this.index = this.index - 1;
      this.createQrPayment(this.index);
    },
    btnNext() {
      this.index = this.index + 1;
      this.createQrPayment(this.index);
    }
  }
}
</script>

<style>
span.title-head {
  color: #0f4c81;
  font-size: 23px;
  font-weight: 600;
}
span.title-bold{
  color: #000000;
  font-size: 20px;
  font-weight: 600;
}
span.label{
  color: #8389a2;
  font-size: 15px;
  font-weight: 400;
}
span.label-bold{
  color: #000000;
  font-size: 15px;
  font-weight: 600;
}
span.label-link{
  color: #0f4c81;
  font-size: 18px;
  font-weight: 600;
}
span.money-bold{
  color: #0f4c81;
  font-size: 23px;
  font-weight: 600;
}
hr{
  border: 0.1px solid #8389a2;
}
.con-vs-popup .vs-popup {
  width: 450px !important;
  height: auto !important;
}
</style>
